import type { NavigationItem } from '~/types';

export const navigationItems: NavigationItem[] = [
  {
    type: 'LINK',
    text: 'navigation.dashboard',
    leftIcon: 'Dashboard',
    url: 'home',
    level: 1,
    dataQa: 'DASHBOARD_MENU_ITEM_DASHBOARD',
    permission: checkNavigationPermission('tdb')
  },
  {
    type: 'DROPDOWN',
    text: 'navigation.accounts',
    leftIcon: 'Accounts',
    dataQa: 'DASHBOARD_MENU_ITEM_ACCOUNTS',
    options: [
      {
        type: 'LINK',
        text: 'navigation.preAccounts',
        url: 'accounts/pending',
        permission: checkNavigationPermission('pre-accounts')
      },
      { type: 'LINK', text: 'navigation.accountsAll', url: 'accounts/all', permission: true }
    ],
    permission: checkNavigationPermission('displayPar')
  },
  {
    type: 'DROPDOWN',
    text: 'navigation.wallets',
    leftIcon: 'AccountBalanceWallet',
    dataQa: 'DASHBOARD_MENU_ITEM_WALLETS',
    permission: checkNavigationPermission('displayPar'),
    options: [
      {
        type: 'LINK',
        text: 'navigation.walletsAll',
        url: 'wallets/all',
        dataQa: 'WALLETS_SUBMENU_ITEM_WALLET_LIST',
        permission: checkNavigationPermission('displayPar')
      },
      {
        type: 'LINK',
        text: 'navigation.walletStatement',
        url: 'wallets/wallet-statement',
        dataQa: 'WALLETS_SUBMENU_ITEM_WALLET_STATEMENT',
        permission: checkNavigationPermission('walletStatement')
      }
    ]
  },
  {
    type: 'DROPDOWN',
    text: 'navigation.transactions',
    leftIcon: 'Transactions',
    dataQa: 'DASHBOARD_MENU_ITEM_TRANSACTIONS',
    permission: true,
    options: [
      {
        type: 'LINK',
        text: 'navigation.transactionsAll',
        url: 'transactions/all',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_TRANSACTIONS_ALL',
        permission: checkNavigationPermission('manageOperations')
      },
      {
        type: 'LINK',
        text: 'navigation.transactionsInOut',
        url: 'transactions/in-out',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_TRANSACTIONS_IN_OUT',
        permission: checkNavigationPermission('manageOperations')
      },
      {
        type: 'LINK',
        text: 'navigation.transactionsP2P',
        url: 'transactions/p2p',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_TRANSACTIONS_P2P',
        permission: checkNavigationPermission('manageOperations')
      },
      {
        type: 'LINK',
        text: 'navigation.transactionsRequests',
        url: 'transactions/requests',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_TRANSACTIONS_REQUESTS',
        permission: checkNavigationPermission('checkRequest')
      }
    ]
  },
  {
    type: 'LINK',
    text: 'navigation.myWallet',
    leftIcon: 'MyAccount',
    url: 'my-wallet/overview',
    level: 1,
    dataQa: 'DASHBOARD_MENU_ITEM_MYWALLET(SC)',
    permission: checkNavigationPermission('proEdit')
  },
  {
    type: 'DROPDOWN',
    text: 'navigation.branding',
    leftIcon: 'Palette',
    dataQa: 'DASHBOARD_MENU_ITEM_BRANDING',
    permission: true,
    options: [
      {
        type: 'LINK',
        text: 'navigation.brand',
        url: 'branding/brand/about',
        dataQa: 'BRANDING_SUBMENU_ITEM_BRAND',
        permission: true
      }
    ]
  },
  {
    type: 'LINK',
    text: 'navigation.reports',
    leftIcon: 'Reports',
    url: 'reports',
    level: 1,
    dataQa: 'DASHBOARD_MENU_ITEM_REPORTS',
    permission: checkNavigationPermission('reports')
  },
  {
    type: 'DROPDOWN',
    text: 'navigation.configuration',
    leftIcon: 'Configuration',
    dataQa: 'DASHBOARD_MENU_ITEM_CONFIGURATION',
    permission: true,
    options: [
      {
        type: 'LINK',
        text: 'navigation.ipAddressWhitelist',
        url: 'configuration/ip-address-whitelist',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_IP_ADDRESS_WHITELIST',
        permission: checkNavigationPermission('manageIpWhiteListBO')
      },
      {
        type: 'LINK',
        text: 'navigation.users',
        url: 'configuration/users/users',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_USER',
        permission: checkNavigationPermission('manageBoUsers')
      },
      {
        type: 'LINK',
        text: 'navigation.roles',
        url: 'configuration/roles',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_ROLES',
        permission: checkNavigationPermission('gestionAccesBo')
      },
      {
        type: 'LINK',
        text: 'navigation.2fa',
        url: 'configuration/2fa',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_TWO_FACTOR_AUTHENTICATION',
        permission: checkNavigationPermission('twoFa')
      },
      {
        type: 'LINK',
        text: 'navigation.approvalWorkflow',
        url: 'configuration/approval-workflow',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_APPROVAL_WORKFLOW',
        permission: true
      }
    ]
  },
  {
    type: 'DROPDOWN',
    text: 'navigation.developers',
    leftIcon: 'Developers',
    dataQa: 'DASHBOARD_MENU_ITEM_DEVELOPERS',
    permission: true,
    options: [
      {
        type: 'EXTERNAL_LINK',
        text: 'navigation.apiDocumentation',
        url: 'https://documentation.lemonway.com',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_API_DOCUMENTATION',
        permission: checkNavigationPermission('documentationLW')
      },
      {
        type: 'LINK',
        text: 'navigation.apiKeys',
        url: 'developers/api-keys',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_API_KEYS',
        permission: checkNavigationPermission('apiKeys')
      },
      {
        type: 'LINK',
        text: 'navigation.notifications',
        url: 'developers/notifications/logs',
        dataQa: 'DASHBOARD_SUBMENU_ITEM_NOTIFICATION',
        permission:
          checkNavigationPermission('notification') &&
          (checkNavigationPermission('notificationHistoric') ||
            checkNavigationPermission('notificationSetting'))
      }
    ]
  },
  {
    type: 'LINK',
    text: 'navigation.changelog',
    leftIcon: 'Changelog',
    url: '#',
    class: 'changelog-trigger',
    textClass: 'changelog-badge',
    dataQa: 'DASHBOARD_MENU_ITEM_CHANGELOG',
    permission: true
  },
  {
    type: 'EXTERNAL_LINK',
    text: 'navigation.statusPage',
    leftIcon: 'StatusPage',
    url: 'https://status.lemonway.com',
    dataQa: 'DASHBOARD_MENU_ITEM_STATUSPAGE',
    permission: checkNavigationPermission('statusPage')
  },
  {
    type: 'EXTERNAL_LINK',
    text: 'navigation.support',
    leftIcon: 'Support',
    url: 'https://support.lemonway.com/hc/fr',
    dataQa: 'DASHBOARD_MENU_ITEM_SUPPORT',
    permission: true
  },
  {
    type: 'CONTACT_POPOVER',
    text: 'navigation.contactUs',
    leftIcon: 'ContactUs',
    dataQa: 'DASHBOARD_MENU_ITEM_CONTACT_US',
    permission: true,
    options: [
      {
        text: '',
        name: 'Support Client (France) +33 1 76 41 06 17',
        phoneNumber: '+33 1 76 41 06 17',
        code: 'fr',
        dataQa: 'CONTACT_US_FRENCH_NUMBER',
        permission: true
      },
      {
        text: '',
        name: 'Support Client (England) +33 1 76 41 06 17',
        phoneNumber: '+33 1 76 41 06 17',
        code: 'en',
        dataQa: 'CONTACT_US_FRENCH_NUMBER',
        permission: true
      },
      {
        text: '',
        name: 'Support Client (Italy) +39 02 8295 0691',
        phoneNumber: '+39 02 8295 0691',
        code: 'it',
        dataQa: 'CONTACT_US_ITALIAN_NUMBER',
        permission: true
      },
      {
        text: '',
        name: 'Support Client (Spain) +34 911 98 86 02',
        phoneNumber: '+34 911 98 86 02',
        code: 'es',
        dataQa: 'CONTACT_US_BRITISH_NUMBER',
        permission: true
      }
    ]
  }
];
